module.exports = __webpack_public_path__ + "img/listria_b2.73c51bcc.jpg";